import { render, staticRenderFns } from "./faceConfirm.vue?vue&type=template&id=77587751&scoped=true"
import script from "./faceConfirm.vue?vue&type=script&lang=ts"
export * from "./faceConfirm.vue?vue&type=script&lang=ts"
import style0 from "./faceConfirm.vue?vue&type=style&index=0&id=77587751&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77587751",
  null
  
)

export default component.exports